import React, { useState, useEffect, useRef } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import priceCalculator from "@heartinz/gst_india_product_price_calculator";
import { CircularProgress } from "@mui/material";

import Messages from "../../../constants/Messages";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import { useNetwork } from "../../../context/NetworkContext";
import handleError from "../../../constants/handleError";
import { usePermission } from "../../../context/PermissionContext";
import { useAuth } from "../../../context/AuthProvider";
import uRLs from "../../../utils/baseUtils";
import CustomUnit from "../product/CustomUnit";
import { AddIcon, CheckIcon, CloseIcon, EditIcon, SaveIcon } from "../../../constants/Icons";

const EditService = ({
  isActive,
  onClose,
  editData,
  onUpdate,
  onMode = "EDIT",
  isBtnLoading,
  estimateSuggest,
  isServiceName = false,
  serviceNameSuggests,
  addNewServiceName,
  loading,
  isSaveBtn = false,
  onAdd,
  showQuanity = true,
}) => {
  // console.log("editData", editData);
  // const [isSelectedRadio, setSelectedRadio] = useState("SALEPRICE");
  const [error, setErrors] = useState({});
  const { settings } = useAuth();
  const [isServiceData, setServiceData] = useState({
    title: "",
    hsnsac: "",
    description: "",
    serviceByName: "",
    mrp: 0,
    quantity: 1,
    saleprice: 0,
    taxpercentage: 0,
    discount: 0,
    baseprice: 0,
    taxamount: 0,
    isStock: false,
    imode: "SERVICE",
    isLock: "SALEPRICE",
  });
  const [AddUnitopen, setAddUnitopen] = useState(false);
  const [unitData, setUnitData] = useState();
  const [unitSuggest, setUnitSuggest] = useState({});
  const serviceTitleRef = useRef(null);
  const quanityRef = useRef(null);
  const serviceDescriptionRef = useRef(null);
  const serviceMrpRef = useRef(null);
  const serviceSalepriceRef = useRef(null);
  const serviceTaxpercentageRef = useRef(null);
  const serviceBasepriceRef = useRef(null);
  const buttonRef = useRef(null);
  const serviceByNameRef = useRef(null);
  const popupMrpInputRef = useRef(null);
  const productHsnsacRef = useRef(null);
  const serviceNameContainerRef = useRef(null);
  const [showTitlePopup, setShowtitlePopup] = useState(false);
  const [showMrpPopup, setShowMrpPopup] = useState(false);
  const [popupMrpValue, setPopupMrpValue] = useState("");
  const [popupMrpStyle, setPopupMrpStyle] = useState({});
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [highlightedServiceIndex, setHighlightedServiceIndex] = useState(-1);
  const [allSuggestions, setAllSuggestions] = useState([]);
  const containerRef = useRef(null);
  const suggestionRef = useRef([]);
  const [addTolist, setAddToList] = useState(true);
  const { checkNetwork } = useNetwork();
  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const requestIdRef = useRef(0);
  const [suggestionLoading, setSuggestionLoading] = useState(false);
  const [serviceNameSuggestions, setserviceNameSuggestions] = useState([]);
  const [serviceNameSuggest, setServiceNameSuggest] =
    useState(serviceNameSuggests);
  const [showServicePopup, setShowServicePopup] = useState(false);
  const { permission, hasModulePermission } = usePermission();

  const showAlert = useShowAlert();
  const allUnits = [
    ...(settings?.defaultUnits || []).map((u) => ({
      unitCode: u.unitCode,
      unitName: u.unitName,
    })),
    ...(settings?.storeUnits || []).map((u) => ({
      unitCode: u.unitCode,
      unitName: u.unitName,
    })),
  ];

  const defaultConversion = allUnits.find(
    (u) => u?.unitCode === unitData?.primaryUnitCode,
  );
  // if (
  //     isServiceData?.title &&
  //     !filteredSuggestions?.some((item) => item?.title === isServiceData?.title)
  //   ) {
  //     setFilteredSuggestions((prev) => [
  //       ...prev,
  //       { title: isServiceData?.title, id: Date.now() }, // add other necessary fields
  //     ]);
  //   }

  const handleSearch = (term, setResults) => {
    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    if (controllerRef.current) controllerRef.current.abort();

    debounceTimerRef.current = setTimeout(async () => {
      try {
        if (!checkNetwork()) return;
        setSuggestionLoading(true);

        controllerRef.current = new AbortController();
        const currentId = ++requestIdRef.current;

        const response = await AxiosInstance.get(
          `module/service/search-hybrid?searchtxt=${term}`,
          { signal: controllerRef.current.signal },
        );

        if (currentId === requestIdRef.current) {
          setResults(response.data.results || []);
        }
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          handleError(error, showAlert);
        }
      } finally {
        setSuggestionLoading(false);
      }
    }, 200);
  };

  const validateForm = () => {
    const errors = {};

    if (!isServiceData.title) {
      errors.title = Messages.ERROR.TITLE_EMPTY;
    } else if (
      isServiceData.hsnsac &&
      !/^99\d{4}$/.test(isServiceData.hsnsac)
    ) {
      errors.hsnsac = Messages.ERROR.INVALID_HSN_SAC;
    } else if (
      isServiceData.mrp === undefined ||
      isServiceData.mrp === null ||
      isServiceData.mrp === ""
    ) {
      errors.mrp = Messages.ERROR.MRP_EMPTY;
      serviceMrpRef.current?.focus();
    } else if (
      isServiceData.mrp &&
      !/^\d*\.?\d{0,2}$/.test(isServiceData.mrp)
    ) {
      errors.mrp = Messages.ERROR.INVALID_INPUT;
      serviceMrpRef.current?.focus();
    } else if (
      isServiceData.saleprice === undefined ||
      isServiceData.saleprice === null ||
      isServiceData.saleprice === ""
    ) {
      errors.saleprice = Messages.ERROR.SALEPRICE_EMPTY;
      serviceSalepriceRef.current?.focus();
    } else if (
      isServiceData.saleprice &&
      !/^\d*\.?\d{0,2}$/.test(isServiceData.saleprice)
    ) {
      errors.saleprice = Messages.ERROR.INVALID_INPUT;
      serviceSalepriceRef.current?.focus();
    } else if (
      isServiceData.taxpercentage === undefined ||
      isServiceData.taxpercentage === null ||
      isServiceData.taxpercentage === ""
    ) {
      errors.taxpercentage = Messages.ERROR.TAX_EMPTY;
      serviceTaxpercentageRef.current?.focus();
    } else if (
      isServiceData.taxpercentage &&
      !/^[0-9]*$/.test(isServiceData.taxpercentage)
    ) {
      errors.taxpercentage = Messages.ERROR.INVALID_INPUT;
      serviceTaxpercentageRef.current?.focus();
    } else if (
      isServiceData.discount === undefined ||
      isServiceData.discount === null ||
      isServiceData.discount === ""
    ) {
      errors.discount = Messages.ERROR.DISCOUNT_EMPTY;
    } else if (
      isServiceData.discount &&
      !/^\d*\.?\d{0,2}$/.test(isServiceData.discount)
    ) {
      errors.discount = Messages.ERROR.INVALID_INPUT;
    } else if (
      isServiceData.baseprice === undefined ||
      isServiceData.baseprice === null ||
      isServiceData.baseprice === ""
    ) {
      errors.baseprice = Messages.ERROR.BASEPRICE_EMPTY;
      serviceBasepriceRef.current?.focus();
    } else if (
      isServiceData.baseprice &&
      !/^\d*\.?\d{0,2}$/.test(isServiceData.baseprice)
    ) {
      errors.baseprice = Messages.ERROR.INVALID_INPUT;
      serviceBasepriceRef.current?.focus();
    } else if (
      isServiceData.taxamount === undefined ||
      isServiceData.taxamount === null ||
      isServiceData.taxamount === ""
    ) {
      errors.taxamount = Messages.ERROR.TAXAMOUNT_EMPTY;
    } else if (
      isServiceData.taxamount &&
      !/^\d*\.?\d{0,2}$/.test(isServiceData.taxamount)
    ) {
      errors.taxamount = Messages.ERROR.INVALID_INPUT;
    }

    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
      switch (firstErrorField) {
        case "title":
          serviceTitleRef.current?.focus();
          break;
        case "hsnsac":
          productHsnsacRef.current?.focus();
          break;
        case "mrp":
          serviceMrpRef.current?.focus();
          break;
        case "saleprice":
          serviceSalepriceRef.current?.focus();
          break;
        case "taxpercentage":
          serviceTaxpercentageRef.current?.focus();
          break;
        case "baseprice":
          serviceBasepriceRef.current?.focus();
          break;
        default:
          break;
      }
    }
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    setErrors("");
    const { name, value } = e.target;
    let inputValue = value;

    if (name === "mrp" || name === "saleprice" || name === "baseprice") {
      const regex = /^\d+(\.\d{0,2})?$/;
      if (!regex.test(value)) inputValue = "";
    }

    // if (name === "title") {
    //   inputValue = value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
    //   // const filtered = estimateSuggest?.filter((s) =>
    //   //   s.title.toLowerCase().includes(value.toLowerCase())
    //   // );
    //   // setFilteredSuggestions(filtered);
    //   // setShowtitlePopup(true);
    // }

    if (name === "title") {
      inputValue = value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
      if (hasModulePermission("SERVICE") || permission === undefined) {
        if (inputValue.length > 0) {
          handleSearch(inputValue, (results) => {
            const withSource = results.map((r) => ({ ...r, source: "api" }));
            setAllSuggestions(withSource);
            setHighlightedIndex(-1);
          });
        } else {
          const filtered = estimateSuggest?.filter((s) =>
            s.title.toLowerCase().includes(inputValue.toLowerCase()),
          );
          const withSource = filtered?.map((r) => ({
            ...r,
            source: "estimate",
          }));
          setAllSuggestions(withSource);
          setHighlightedIndex(-1);
        }

        setShowtitlePopup(true);
      }
    }

    if (name === "hsnsac") {
      // allow empty
      if (value === "") {
        inputValue = "";
      } else {
        // exactly 6 digits, starting with 99
        const regex = /^\d{0,6}$/;
        if (!regex.test(value)) {
          return; //  block invalid typing
        }
        inputValue = value;
      }
    }

    if (name === "quantity") {
      if (uRLs.UNIT === "true") {
        if (!/^\d*$/.test(value)) {
          return;
        }
      }
    }

    if (name === "serviceByName") {
      const filtered = serviceNameSuggest?.filter((s) =>
        s.serviceByName.toLowerCase().includes(inputValue.toLowerCase()),
      );
      // console.log("filtered", filtered);
      setserviceNameSuggestions(filtered);
      setHighlightedServiceIndex(-1);
      setShowServicePopup(true);
    }

    if (name === "taxpercentage") {
      const allowedValues = [0, 5, 12, 18, 24];
      const parsedValue = parseInt(value);
      if (isNaN(parsedValue) || !allowedValues.includes(parsedValue)) {
        inputValue = 0;
      } else {
        inputValue = parsedValue;
      }
    }

    const updateData = {
      ...isServiceData,
      [name]: inputValue,
    };
    setServiceData(updateData);
    handleCalculate(updateData);
  };

  const handleUnit = (payload) => {
    if (!payload) return;

    setUnitData({
      primaryUnitName: payload?.primaryUnitName,
      primaryUnitCode: payload?.primaryUnitCode,
    });

    setUnitSuggest((prev) => {
      let updatedStore = [...(prev?.storeUnits || [])];

      // combine default + store units for checking
      const allUnits = [
        ...(prev?.defaultUnits || []),
        ...(prev?.storeUnits || []),
      ];

      // check primary unit
      const primaryExists = allUnits.some(
        (u) => u.unitCode === payload?.primaryUnitCode,
      );

      if (!primaryExists) {
        updatedStore.push({
          unitName: payload?.primaryUnitName,
          unitCode: payload?.primaryUnitCode,
        });
      }

      // check secondary unit
      if (payload?.secondaryUnitCode) {
        const secondaryExists = allUnits.some(
          (u) => u.unitCode === payload?.secondaryUnitCode,
        );

        if (!secondaryExists) {
          updatedStore.push({
            unitName: payload?.secondaryUnitName,
            unitCode: payload?.secondaryUnitCode,
          });
        }
      }

      return {
        ...prev,
        storeUnits: updatedStore,
      };
    });
  };

  // const handleKeyDown = (e, title, nextRef) => {
  //   if (e.key === "ArrowDown") {
  //     e.preventDefault();
  //     setHighlightedIndex((prev) =>
  //       Math.min(prev + 1, filteredSuggestions.length - 1)
  //     );
  //   } else if (e.key === "ArrowUp") {
  //     e.preventDefault();
  //     setHighlightedIndex((prev) => Math.max(prev - 1, 0));
  //   } else if (e.key === "Enter") {
  //     e.preventDefault();
  //     if (highlightedIndex >= 0) {
  //       const selected = filteredSuggestions[highlightedIndex];
  //       if (selected) {
  //         setServiceData((prev) => ({
  //           ...prev,
  //           title: selected.title,
  //           hsnsac: selected.hsnsac,
  //           taxpercentage:selected.taxpercentage||0,
  //         }));
  //         setShowtitlePopup(false);
  //         setHighlightedIndex(-1);
  //         // Move focus to next field
  //         setTimeout(() => {
  //           nextRef?.current?.focus();
  //         }, 0); // Slight delay ensures DOM updates complete
  //       }
  //     } else {
  //       if (!title || title.trim() === "") {
  //         setErrors({ title: Messages.ERROR.TITLE_EMPTY });
  //         return;
  //       }
  //       setShowtitlePopup(false);
  //       setErrors({});
  //       nextRef?.current?.focus();
  //     }
  //   }
  // };

  const handleKeyDown = (e, title, nextRef) => {
    const activeList = allSuggestions;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.min(prev + 1, activeList?.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightedIndex >= 0) {
        const selected = activeList[highlightedIndex];
        if (selected.source === "estimate") {
          if (selected?.serviceId) {
            const updateDate = {
              ...selected,
              _id: selected?.serviceId,
              serviceByName: isServiceData.serviceByName,
            };
            setAddToList(false);
            openEditModal(updateDate);
          } else {
            setAddToList(true);
            resetForm();
            setServiceData((prev) => ({
              ...prev,
              imode: "SERVICE",
              isStock: false,
              isLock: "SALEPRICE",
              title: selected.title,
              hsnsac: selected.hsnsac,
              taxpercentage: selected.taxpercentage || 0,
              description: selected?.description || prev.description, // ✅ KEEP
              serviceByName: isServiceData.serviceByName,
            }));
          }
          setShowtitlePopup(false);
          setHighlightedIndex(-1);
          setTimeout(() => nextRef?.current?.focus(), 0);
        } else if (selected.source === "api") {
          resetForm();
          const updateDate = {
            ...selected,
            serviceByName: isServiceData.serviceByName,
          };
          setAddToList(true);
          openEditModal(updateDate); // modal only opens on Enter
          setShowtitlePopup(false);
          setHighlightedIndex(-1);
          setTimeout(() => nextRef?.current?.focus(), 0);
        }
      } else {
        if (!title || title.trim() === "") {
          setErrors({ title: Messages.ERROR.TITLE_EMPTY });
          return;
        }
        setShowtitlePopup(false);
        setErrors({});
        nextRef?.current?.focus();
      }
    }
  };
  useEffect(() => {
    if (showMrpPopup && popupMrpInputRef.current) {
      popupMrpInputRef.current.focus();
      popupMrpInputRef.current.select();
    }
  }, [showMrpPopup]);

  const handleEnterFocus = (e, nextRef) => {
    if (e.key === "Enter") {
      // console.log("handleEnterFocus");
      e.preventDefault();
      nextRef?.current?.focus();

      if (nextRef === serviceMrpRef) {
        const rect = nextRef.current.getBoundingClientRect();
        setPopupMrpStyle({
          position: "absolute",
          top: `${rect.top + window.scrollY}px`,
          left: `${rect.left + window.scrollX}px`,
          width: `${rect.width}px`,
          zIndex: 10000,
        });
        setPopupMrpValue(isServiceData.mrp);
        setShowMrpPopup(true);
      }
    }
  };

  const handlePaymodeKeyDowns = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleService(e, "update");
    }
  };

  const handlePaymodeKeyDown = (e) => {
    if (!showServicePopup) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedServiceIndex((prev) =>
        prev < serviceNameSuggestions.length - 1 ? prev + 1 : 0,
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedServiceIndex((prev) =>
        prev > 0 ? prev - 1 : serviceNameSuggestions.length - 1,
      );
    } else if (e.key === "Enter") {
      e.preventDefault();

      if (
        highlightedServiceIndex >= 0 &&
        serviceNameSuggestions[highlightedServiceIndex]
      ) {
        const selectedService = serviceNameSuggestions[highlightedServiceIndex];
        const updatedData = {
          ...isServiceData,
          serviceByName: selectedService.serviceByName,
        };

        setServiceData(updatedData);
        handleService(e, "update", updatedData);
      } else {
        const newService = isServiceData?.serviceByName?.trim();
        if (newService) {
          //  Call parent callback instead of local setServiceNameSuggest
          addNewServiceName(newService);

          const updatedData = { ...isServiceData, serviceByName: newService };
          setServiceData(updatedData);
          handleService(e, "update", updatedData);
        }
      }

      setShowServicePopup(false);
      setHighlightedServiceIndex(-1);
    } else if (e.key === "Escape") {
      setShowServicePopup(false);
      setHighlightedServiceIndex(-1);
    }
  };

  const handleCalculate = (updateData) => {
    var { mrp, saleprice, baseprice, taxpercentage, quantity } = updateData;
    let numericMrp = CurrencyConverter.toSubunit(mrp || 0, "INR");
    let numericSaleprice = CurrencyConverter.toSubunit(saleprice || 0, "INR");
    let numericBaseprice = CurrencyConverter.toSubunit(baseprice || 0, "INR");
    let numericTaxpercentage = parseInt(taxpercentage);
    let quanity = Number(quantity || 1);
    let calculationResult;
    let lock = isServiceData.isLock;
    try {
      calculationResult = priceCalculator.getAllPriceList(
        numericMrp,
        numericSaleprice,
        numericBaseprice,
        numericTaxpercentage,
        quanity,
        lock,
      );

      if (lock === "SALEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setServiceData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            baseprice: CurrencyConverter.toCurrency(
              calculationResult.basePrice,
              "INR",
            ),
          }));
        }
        setServiceData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          baseprice: CurrencyConverter.toCurrency(
            calculationResult.basePrice,
            "INR",
          ),
        }));
      } else if (lock === "BASEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setServiceData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            saleprice: CurrencyConverter.toCurrency(
              calculationResult.salePrice,
              "INR",
            ),
          }));
        }
        setServiceData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          saleprice: CurrencyConverter.toCurrency(
            calculationResult.salePrice,
            "INR",
          ),
        }));
      }
    } catch (error) {
      showAlert("warning", error.message || Messages.ERROR.INVALID_INPUT);
    }
  };

  const handleService = (event, type, data) => {
    var quanity = isServiceData?.quantity;
    event.preventDefault();
    if (!validateForm()) return;
    const baseData = data || isServiceData;
    const nodata = serviceNameSuggestions.some(
      (it) => it.serviceByName === baseData?.serviceByName,
    );
    if (isServiceName) {
      if (!nodata) {
        addNewServiceName(baseData?.serviceByName?.trim());
      }
    }
    const editDatas = {
      ...baseData,
      hsnsac: baseData.hsnsac || "",
      mrp: CurrencyConverter.toSubunit(baseData.mrp || 0, "INR"),
      saleprice: CurrencyConverter.toSubunit(baseData.saleprice || 0, "INR"),
      soldprice: CurrencyConverter.toSubunit(baseData.saleprice || 0, "INR"),
      taxpercentage: baseData.taxpercentage || 0,
      discount: CurrencyConverter.toSubunit(baseData.discount || 0, "INR"),
      baseprice: CurrencyConverter.toSubunit(baseData.baseprice || 0, "INR"),
      taxamount: CurrencyConverter.toSubunit(baseData.taxamount || 0, "INR"),
      isLock: baseData.isLock,
      uniqueId: editData.uniqueId,
      unitConfig: unitData,
      // serviceByName:isServiceData.serviceByName,
    };
    onUpdate(editDatas, quanity, onMode, type);
  };

  const handleAddService = (event, data) => {
    var quanity = isServiceData?.quantity;
    event.preventDefault();
    if (!validateForm()) return;
    const baseData = data || isServiceData;
    const nodata = serviceNameSuggestions.some(
      (it) => it.serviceByName === baseData?.serviceByName,
    );
    if (isServiceName) {
      if (!nodata) {
        addNewServiceName(baseData?.serviceByName?.trim());
      }
    }
    const addData = {
      ...baseData,
      mrp: CurrencyConverter.toSubunit(baseData.mrp || 0, "INR"),
      saleprice: CurrencyConverter.toSubunit(baseData.saleprice || 0, "INR"),
      soldprice: CurrencyConverter.toSubunit(baseData.saleprice || 0, "INR"),
      taxpercentage: baseData.taxpercentage || 0,
      discount: CurrencyConverter.toSubunit(baseData.discount || 0, "INR"),
      baseprice: CurrencyConverter.toSubunit(baseData.baseprice || 0, "INR"),
      taxamount: CurrencyConverter.toSubunit(baseData.taxamount || 0, "INR"),
      isLock: baseData.isLock,
      uniqueId: Date.now() + Math.floor(Math.random() * 10000),
      unitConfig: unitData,
    };
    onAdd(addData, quanity, onMode);
    // console.log("addData",addData)
  };

  const openEditModal = async (cItem) => {
    try {
      const response = await AxiosInstance.get(`/module/service/${cItem?._id}`);
      if (response?.data) {
        const serviceData = response.data.results;
        setServiceData((prev) => ({
          ...prev,
          ...serviceData,
          description: serviceData?.description || prev.description, // ✅ PRESERVE
          mrp: CurrencyConverter.toCurrency(serviceData.mrp || 0, "INR"),
          saleprice: CurrencyConverter.toCurrency(
            serviceData.saleprice || 0,
            "INR",
          ),
          discount: CurrencyConverter.toCurrency(
            serviceData.discount || 0,
            "INR",
          ),
          baseprice: CurrencyConverter.toCurrency(
            serviceData.baseprice || 0,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            serviceData.taxamount || 0,
            "INR",
          ),
          imode: "SERVICE",
          isStock: false,
          serviceByName: cItem.serviceByName,
        }));
        setUnitData(serviceData?.unitConfig);
      }
      // setEditModalOpen(true);
    } catch (error) {
      if (error?.response?.status === 404) {
        // 👉 Prefill title only
        resetForm();
        setServiceData((prev) => ({
          ...prev,
          title: cItem?.title || "",
          imode: "SERVICE",
          isStock: false,
          isLock: "SALEPRICE",
        }));
        return;
      }

      console.error("Failed to fetch service details:", error);
      showAlert("error", "Unable to fetch service details");
    }
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const resetForm = () => {
    setServiceData({
      code: "",
      hsnsac: "",
      title: "",
      // serviceByName:"",
      mrp: 0,
      saleprice: 0,
      taxpercentage: 0,
      discount: 0,
      baseprice: 0,
      taxamount: 0,
    });
    setUnitData();
    setErrors("");
  };

  const handleRadioChange = (inputName) => {
    setServiceData((prev) => ({
      ...prev,
      isLock: inputName,
    }));
    // setSelectedRadio(inputName);
  };

  useEffect(() => {
    if (!isActive) return;

    if (document.visibilityState !== "visible") return;

    const timer = setTimeout(() => {
      serviceTitleRef.current?.focus();
    }, 120);

    return () => clearTimeout(timer);
  }, [isActive]);

  useEffect(() => {
    if (highlightedIndex >= 0 && suggestionRef.current[highlightedIndex]) {
      suggestionRef.current[highlightedIndex].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
    if (
      highlightedServiceIndex >= 0 &&
      suggestionRef.current[highlightedServiceIndex]
    ) {
      suggestionRef.current[highlightedServiceIndex].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [highlightedIndex, highlightedServiceIndex]);

  useEffect(() => {
    if (editData) {
      const updatedData = {
        ...editData,
        isLock: editData.isLock || "SALEPRICE",
      };
      setServiceData(updatedData);
      setUnitData(updatedData?.unitConfig);
      serviceTitleRef.current?.focus();
    }
  }, [editData]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowtitlePopup(false);
      }
      if (
        serviceNameContainerRef.current &&
        !serviceNameContainerRef.current.contains(e.target)
      ) {
        setShowServicePopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isServiceData?.title) {
      const value = isServiceData.title.toLowerCase();
      const filtered = estimateSuggest?.filter((s) =>
        s.title.toLowerCase().includes(value),
      );
      const withSource = filtered?.map((r) => ({
        ...r,
        source: "estimate",
      }));
      setAllSuggestions(withSource);
      setHighlightedIndex(-1);
      // setShowtitlePopup(true); // 👉 force popup visible on first time
    }
  }, [isServiceData?.title, estimateSuggest]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  useEffect(() => {
    setUnitSuggest({
      defaultUnits: settings?.defaultUnits || [],
      storeUnits: settings?.storeUnits || [],
    });
  }, []);

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title"> Edit Service </h6>
              <button
                type="button"
                onClick={handleClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-lg-7">
                  <div className="row g-3">
                    <div className="col-lg-8">
                      <label htmlFor="title" className="form-label">
                        Title <span className="text-danger">*</span>
                      </label>
                      <div className="position-relative" ref={containerRef}>
                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          autoComplete="off"
                          ref={serviceTitleRef}
                          value={isServiceData.title}
                          onChange={handleChange}
                          onFocus={() => {
                            // handleSuggestEstimate();
                            setShowtitlePopup(true);
                            const value =
                              isServiceData.title?.toLowerCase() || "";
                            // const filtered = estimateSuggest?.filter((item) =>
                            //   item?.title?.toLowerCase().includes(value)
                            // );
                            // setFilteredSuggestions(filtered);
                            // setHighlightedIndex(-1);
                            const filtered = estimateSuggest?.filter((s) =>
                              s.title
                                .toLowerCase()
                                .includes(value.toLowerCase()),
                            );
                            const withSource = filtered?.map((r) => ({
                              ...r,
                              source: "estimate",
                            }));
                            setAllSuggestions(withSource);
                            setHighlightedIndex(-1);
                          }}
                          onKeyDown={(e) =>
                            handleKeyDown(
                              e,
                              isServiceData.title,
                              productHsnsacRef,
                            )
                          }
                        />
                        {(hasModulePermission("SERVICE") ||
                          permission === undefined) &&
                          showTitlePopup &&
                          allSuggestions?.length > 0 && (
                            <ul
                              className="suggestions-list"
                              style={{ maxHeight: "150px" }}
                            >
                              {allSuggestions?.map((service, index) => (
                                <li
                                  key={service?._id || index}
                                  ref={(e) =>
                                    (suggestionRef.current[index] = e)
                                  }
                                  // onMouseEnter={() => {
                                  //   if (service.source === "estimate") {
                                  //     if (service?.serviceId) {
                                  //       const updateDate = {
                                  //         ...service,
                                  //         _id: service?.serviceId,
                                  //       };
                                  //       openEditModal(updateDate);
                                  //     } else {
                                  //       resetForm();
                                  //       setServiceData((prev) => ({
                                  //         ...prev,
                                  //         title: service?.title,
                                  //         hsnsac: service?.hsnsac,
                                  //         taxpercentage:
                                  //           service?.taxpercentage || 0,
                                  //         imode: "SERVICE",
                                  //         isStock: false,
                                  //         isLock: "SALEPRICE",
                                  //       }));
                                  //     }
                                  //   } else if (service.source === "api") {
                                  //     // API suggestion → open modal when hovered
                                  //     openEditModal(service);
                                  //   }
                                  // }}
                                  // onMouseLeave={resetForm}
                                  onMouseDown={() => {
                                    if (service.source === "estimate") {
                                      // Estimate suggestion → just set data
                                      if (service?.serviceId) {
                                        const updateDate = {
                                          ...service,
                                          _id: service?.serviceId,
                                        };
                                        openEditModal(updateDate);
                                        setAddToList(false);
                                      } else {
                                        resetForm();
                                        setAddToList(true);
                                        setServiceData((prev) => ({
                                          ...prev,
                                          title: service?.title,
                                          hsnsac: service?.hsnsac,
                                          taxpercentage:
                                            service?.taxpercentage || 0,
                                          description:
                                            service?.description ||
                                            prev.description, // ✅ KEEP if empty
                                          imode: "SERVICE",
                                          isStock: false,
                                          isLock: "SALEPRICE",
                                        }));
                                      }
                                    } else if (service?.source === "api") {
                                      // API suggestion → set data + open modal
                                      // setServiceData((prev) => ({
                                      //   ...prev,
                                      //   title: service?.title,
                                      //   hsnsac: service?.hsnsac,
                                      //   taxpercentage: service?.taxpercentage || 0,
                                      // }));
                                      openEditModal(service);
                                      setAddToList(true);
                                    }

                                    setShowtitlePopup(false);
                                    setHighlightedIndex(-1);
                                  }}
                                  className={`suggestion-item ${
                                    highlightedIndex === index
                                      ? "highlighted"
                                      : ""
                                  }`}
                                >
                                  {service?.title}
                                </li>
                              ))}
                            </ul>
                          )}
                      </div>
                      {error.title && (
                        <div className="invalid-feedback">{error.title}</div>
                      )}
                    </div>

                    {/* {uRLs.UNIT === "true" && (
                      <div className="col-lg-3 col-12">
                        <label htmlFor="unit" className="form-label">
                          Unit
                        </label>
                        <div className="d-flex align-items-center">
                          <button
                            type="button"
                            className="btn btn-unit fs-10 w-100 d-flex align-items-center justify-content-between"
                            onClick={() => {
                              // if(isServiceData?.unitConfig || "unitLocked" in isServiceData){
                              if (
                                !isServiceData.unitLocked ||
                                !("unitLocked" in isServiceData)
                              ) {
                                setAddUnitopen(true);
                              }
                            }}
                            // }
                          >
                            {defaultConversion?.unitName ? (
                              <>
                                <span>{defaultConversion?.unitName}</span>
                                {!isServiceData.unitLocked && (
                                  <i className="ng ng-ng-edit-icon me-1"></i>
                                )}{" "}
                              </>
                            ) : (
                              <>
                                <span>Unit</span>{" "}
                                {(!isServiceData.unitLocked ||
                                  !("unitLocked" in isServiceData)) && (
                                  <i className="ng ng-ng-add-icon me-1"></i>
                                )}{" "}
                              </>
                            )}
                          </button>
                        </div>
                        {unitData && (
                          <span>
                            1 {unitData?.primaryUnitCode} ={" "}
                            {unitData?.secondaryUnitCode
                              ? `${unitData?.conversion} ${unitData?.secondaryUnitCode}`
                              : "1 Unit"}
                          </span>
                        )}
                      </div>
                    )} */}
                    <div className="col-lg-4 ">
                      <label htmlFor="hsnsac" className="form-label">
                        {" "}
                        HSN/SAC{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="hsnsac"
                        autoComplete="off"
                        ref={productHsnsacRef}
                        onKeyDown={(e) =>
                          handleEnterFocus(e, serviceDescriptionRef)
                        }
                        value={isServiceData?.hsnsac}
                        onChange={handleChange}
                      />
                      {error.hsnsac && (
                        <div className="invalid-feedback">{error.hsnsac}</div>
                      )}
                    </div>
                    <div className="col-lg-12">
                      <label htmlFor="description" className="form-label">
                        Description
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        name="description"
                        autoComplete="off"
                        ref={serviceDescriptionRef}
                        value={isServiceData?.description}
                        onChange={handleChange}
                        // onKeyDown={(e) => handleEnterFocus(e, serviceMrpRef)}
                        rows={isServiceName ? 9 : 5}
                      ></textarea>
                      {error.description && (
                        <div className="invalid-feedback">
                          {error.description}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-lg-5">
                  <div className="row g-3">
                    {/* <div className="col-lg-6">
                      <label htmlFor="mrp" className="form-label">
                        {" "}
                        MRP{" "}
                      </label>
                      {!showMrpPopup && (
                        <input
                          type="text"
                          className="form-control"
                          name="mrp"
                          autoComplete="off"
                          ref={serviceMrpRef}
                          value={isServiceData?.mrp}
                          onClick={() => {
                            const rect =
                              serviceMrpRef.current.getBoundingClientRect();
                            setPopupMrpStyle({
                              position: "absolute",
                              top: `${rect.top + window.scrollY}px`,
                              left: `${rect.left + window.scrollX}px`,
                              width: `${rect.width}px`,
                              zIndex: 10000,
                            });
                            setPopupMrpValue(isServiceData.mrp);
                            setShowMrpPopup(true);
                          }}
                          onFocus={(e) => e.target.select()}
                          onChange={handleChange}
                          onKeyDown={(e) =>
                            handleEnterFocus(e, serviceTaxpercentageRef)
                          }
                        />
                      )}
                      {showMrpPopup && (
                        <input
                          type="text"
                          ref={popupMrpInputRef}
                          value={popupMrpValue}
                          onChange={(e) => {
                            const val = e.target.value;

                            // Regex: only digits, optional one dot, up to 2 decimals
                            const regex = /^\d+(\.\d{0,2})?$/;

                            if (val === "" || regex.test(val)) {
                              setPopupMrpValue(val);
                              setServiceData((prev) => ({ ...prev, mrp: val }));
                              handleCalculate({ ...isServiceData, mrp: val });
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              setShowMrpPopup(false);
                              setTimeout(() => {
                                serviceTaxpercentageRef?.current?.focus();
                              }, 0);
                            }
                          }}
                          onBlur={() => setShowMrpPopup(false)}
                          autoFocus
                          // style={popupMrpStyle}
                          className="form-control"
                        />
                      )}
                      {error.mrp && (
                        <div className="invalid-feedback">{error.mrp}</div>
                      )}
                    </div> */}

                    {uRLs.UNIT === "true" && (
                      <div
                        className={
                          showQuanity ? `col-lg-6 col-12` : "col-12 col-lg-6"
                        }
                      >
                        <label htmlFor="unit" className="form-label">
                          Unit
                        </label>
                        <div className="d-flex align-items-center">
                          <button
                            type="button"
                            className="btn btn-unit fs-10 w-100 d-flex align-items-center justify-content-between"
                            onClick={() => {
                              // if(isServiceData?.unitConfig || "unitLocked" in isServiceData){
                              if (
                                !isServiceData.unitLocked ||
                                !("unitLocked" in isServiceData)
                              ) {
                                setAddUnitopen(true);
                              }
                            }}
                            // }
                          >
                            {defaultConversion?.unitName ? (
                              <>
                                <span>{defaultConversion?.unitName}</span>
                                {!isServiceData.unitLocked && (
                                  <EditIcon iClass={"me-1"}/>
                                )}{" "}
                              </>
                            ) : (
                              <>
                                <span>Unit</span>{" "}
                                {(!isServiceData.unitLocked ||
                                  !("unitLocked" in isServiceData)) && (
                                  <AddIcon iClass={"me-1"}/>
                                )}{" "}
                              </>
                            )}
                          </button>
                        </div>
                        {unitData && (
                          <span>
                            1 {unitData?.primaryUnitCode} ={" "}
                            {unitData?.secondaryUnitCode
                              ? `${unitData?.conversion} ${unitData?.secondaryUnitCode}`
                              : "1 Unit"}
                          </span>
                        )}
                      </div>
                    )}
                    {!showQuanity && <div className="col-6"></div>}
                    {showQuanity && (
                      <div className="col-lg-6">
                        <label htmlFor="quantity" className="form-label">
                          Quanity <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            name="quantity"
                            autoComplete="off"
                            ref={quanityRef}
                            value={isServiceData.quantity}
                            onChange={handleChange}
                            onFocus={(e) => e.target.select()}
                            onKeyDown={(e) => {
                              handleEnterFocus(e, serviceMrpRef);
                            }}
                          />
                          {error.quantity && (
                            <div className="invalid-feedback">
                              {error.quantity}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    <div className="col-lg-6">
                      <label htmlFor="saleprice" className="form-label">
                        Amount With Tax <span className="text-danger">*</span>
                      </label>

                      <div className="input-container position-relative">
                        <input
                          type="text"
                          name="saleprice"
                          autoComplete="off"
                          ref={serviceSalepriceRef}
                          value={isServiceData?.saleprice}
                          onKeyDown={(e) =>
                            handleEnterFocus(e, serviceBasepriceRef)
                          }
                          className="form-control"
                          onFocus={(e) => e.target.select()}
                          onClick={() => handleRadioChange("SALEPRICE")}
                          style={{ paddingLeft: "30px" }}
                          onChange={handleChange}
                        />
                        <input
                          type="radio"
                          name="selectInput"
                          checked={isServiceData.isLock === "SALEPRICE"}
                          className="position-absolute"
                          style={{
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            zIndex: 2,
                          }}
                        />
                      </div>
                      {error.saleprice && (
                        <div className="invalid-feedback">
                          {error.saleprice}
                        </div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <label htmlFor="FisrtName" className="form-label">
                        Tax(%) <span className="text-danger">*</span>
                      </label>
                      <select
                        name="taxpercentage"
                        className="form-select"
                        ref={serviceTaxpercentageRef}
                        value={isServiceData?.taxpercentage}
                        onChange={handleChange}
                        onKeyDown={(e) =>
                          handleEnterFocus(e, serviceSalepriceRef)
                        }
                      >
                        <option value="0">0</option>
                        <option value="5">5</option>
                        <option value="12">12</option>
                        <option value="18">18</option>
                        <option value="24">24</option>
                      </select>
                    </div>

                    {/* <div className="col-lg-6">
                      <label htmlFor="discount" className="form-label">
                        Discount
                      </label>
                      <input
                        readOnly=""
                        type="text"
                        name="discount"
                        autoComplete="off"
                        value={isServiceData?.discount}
                        className="form-control"
                        disabled
                      />
                    </div> */}
                    <div className="col-lg-6">
                      <label htmlFor="baseprice" className="form-label">
                        Amount Without Tax
                      </label>
                      <div className="input-container position-relative">
                        <input
                          type="text"
                          name="baseprice"
                          autoComplete="off"
                          ref={serviceBasepriceRef}
                          onClick={() => handleRadioChange("BASEPRICE")}
                          onChange={handleChange}
                          value={isServiceData?.baseprice}
                          // onKeyDown={handlePaymodeKeyDown}
                          onKeyDown={(e) => {
                            if (isServiceName) {
                              // only try to move focus if the field actually exists
                              handleEnterFocus(e, serviceByNameRef);
                            } else {
                              handlePaymodeKeyDowns(e);
                            }
                          }}
                          onFocus={(e) => e.target.select()}
                          className="form-control"
                          style={{ paddingLeft: "30px" }}
                        />
                        <input
                          type="radio"
                          name="selectInput"
                          className="position-absolute"
                          checked={isServiceData.isLock === "BASEPRICE"}
                          style={{
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            zIndex: 2,
                          }}
                        />
                      </div>
                      {error.baseprice && (
                        <div className="invalid-feedback">
                          {error.baseprice}
                        </div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <label htmlFor="taxamount" className="form-label">
                        Tax Amount
                      </label>
                      <input
                        readOnly=""
                        type="text"
                        name="taxamount"
                        autoComplete="off"
                        className="form-control"
                        value={isServiceData?.taxamount}
                        disabled
                      />
                    </div>
                    {/* {isServiceName && (
                      <div className="col-lg-12">
                        <label htmlFor="serviceByName" className="form-label">
                          {" "}
                          <i className="bx bx-user me-1"></i>Service Done
                          By{" "}
                        </label>
                        <div
                          className="position-relative"
                          ref={serviceNameContainerRef}
                        >
                          <input
                            type="text"
                            className="form-control"
                            name="serviceByName"
                            autoComplete="off"
                            ref={serviceByNameRef}
                            onKeyDown={handlePaymodeKeyDown}
                            value={isServiceData?.serviceByName}
                            onChange={handleChange}
                            onFocus={() => {
                              setShowServicePopup(true);
                              const value =
                                isServiceData.serviceByName?.toLowerCase() ||
                                "";
                              const filtered = serviceNameSuggest?.filter(
                                (item) =>
                                  item?.serviceByName
                                    ?.toLowerCase()
                                    .includes(value),
                              );
                              setserviceNameSuggestions(filtered);
                              setHighlightedServiceIndex(-1);
                            }}
                          />
                          {showServicePopup &&
                            serviceNameSuggestions?.length > 0 && (
                              <ul
                                className="suggestions-list-top"
                                style={{ maxHeight: "150px" }}
                              >
                                {serviceNameSuggestions?.map(
                                  (service, index) => (
                                    <li
                                      key={service?._id || index}
                                      ref={(e) =>
                                        (suggestionRef.current[index] = e)
                                      }
                                      // onMouseLeave={resetForm}
                                      onMouseDown={() => {
                                        setServiceData((prev) => ({
                                          ...prev,
                                          serviceByName: service.serviceByName,
                                        }));
                                        setShowServicePopup(false);
                                        setHighlightedServiceIndex(-1);
                                      }}
                                      className={`suggestion-item ${
                                        highlightedServiceIndex === index
                                          ? "highlighted"
                                          : ""
                                      }`}
                                    >
                                      {service?.serviceByName}
                                    </li>
                                  ),
                                )}
                              </ul>
                            )}
                        </div>
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={handleClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <CloseIcon iClass={"fs-15"}/> Cancel
              </button>
              {isBtnLoading ? (
                <button className="btn btn-primary pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  ref={buttonRef}
                  type="button"
                  className="btn btn-primary text-right"
                  onClick={(e) => handleService(e, "update")}
                >
                  <CheckIcon/> Done
                </button>
              )}
              {isSaveBtn && (
                <>
                  {loading?.saveButton ? (
                    <button
                      className="btn btn-primary pb-0 text-right"
                      disabled
                    >
                      <CircularProgress size={22} className="text-white" />
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-primary text-right"
                      onClick={(e) => handleService(e, "save")}
                    >
                      <SaveIcon/> Save
                    </button>
                  )}
                  {addTolist &&
                    (loading?.addServiseList ? (
                      <button
                        className="btn btn-primary pb-0 text-right"
                        disabled
                      >
                        <CircularProgress size={22} className="text-white" />
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-jobcard text-right me-lg-5"
                        onClick={(e) => handleAddService(e)}
                      >
                        <AddIcon/> Add To Service
                        List
                      </button>
                    ))}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {AddUnitopen && (
        <CustomUnit
          onclose={() => {
            setAddUnitopen(false);
          }}
          unitSuggest={unitSuggest}
          onAdd={handleUnit}
          selectedData={unitData}
          showSecondary={false}
          summitAuto={true}
        />
      )}
    </div>
  );
};

export default EditService;
